import React from 'react';
import { FormControl, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { Copy } from 'lucide-react';
import { RiBrushAiFill } from 'react-icons/ri';
import { copyFolioToClipboard } from '../../helpers/folioCopyHelper';

const copyActions = [
  {
    key: 'as-entered',
    title: 'Copy folio number as entered',
    cleaned: false,
    icon: <Copy size={16} className="text-muted" />
  },
  {
    key: 'cleaned',
    title: 'Copy cleaned folio number',
    cleaned: true,
    icon: <RiBrushAiFill size={16} style={{ color: '#f59e0b' }} />
  }
];

const FolioInputWithCopy = ({
  value,
  onChange,
  style,
  className = 'midFont',
  size = 'lg',
  ...rest
}) => {
  const hasFolio = Boolean(String(value ?? '').trim());
  const borderColor = style?.borderColor || '#ced4da';

  return (
    <div className="position-relative">
      <FormControl
        size={size}
        className={className}
        type="text"
        value={value}
        onChange={onChange}
        style={{ ...style, paddingRight: '4.75rem' }}
        {...rest}
      />
      <div
        className="position-absolute d-flex align-items-stretch"
        style={{
          top: 1,
          right: 1,
          bottom: 1,
          overflow: 'hidden',
          borderTopRightRadius: '9px',
          borderBottomRightRadius: '9px',
          borderLeft: `1px solid ${borderColor}`
        }}
      >
        {copyActions.map(({ key, title, cleaned, icon }, index) => (
          <OverlayTrigger
            key={key}
            placement="top"
            overlay={<Tooltip id={`folio-copy-${key}`}>{title}</Tooltip>}
          >
            <button
              type="button"
              disabled={!hasFolio}
              className="m-0 d-inline-flex align-items-center justify-content-center"
              style={{
                width: '2.15rem',
                padding: 0,
                backgroundColor: '#e8f1fb',
                border: 'none',
                borderLeft: index === 0 ? 'none' : `1px solid ${borderColor}`,
                borderRadius: 0,
                cursor: hasFolio ? 'pointer' : 'not-allowed',
                opacity: hasFolio ? 1 : 0.45,
                lineHeight: 0,
                pointerEvents: 'auto'
              }}
              onClick={() => copyFolioToClipboard(value, { cleaned })}
            >
              {icon}
            </button>
          </OverlayTrigger>
        ))}
      </div>
    </div>
  );
};

export default FolioInputWithCopy;
